<!-- Actions cell template — outside the tab *ngIf blocks so ViewChild resolves on init. -->
<ng-template #actionsCell let-row>
  <div class="mfm-row-actions">
    <button type="button" class="btn-icon btn-upload" (click)="downloadFile(row)" title="Download file">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2v8m0 0 3-3m-3 3-3-3M2 12.667h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button type="button" class="btn-icon btn-delete-file" (click)="deleteFile(row)" title="Delete file">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</ng-template>

<app-modal
  [visible]="true"
  [header]="'Manage Files' + (assetName ? ' — ' + assetName : '')"
  [width]="'860px'"
  [showFooter]="false"
  (onCancel)="close()"
  (onClose)="close()"
>
  <div class="manage-files-modal">
    <div class="manage-files-modal__tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="manage-files-modal__tab"
        [class.manage-files-modal__tab--active]="activeTab === 'files'"
        (click)="setActiveTab('files')"
      >
        Files
      </button>
      <button
        type="button"
        role="tab"
        class="manage-files-modal__tab"
        [class.manage-files-modal__tab--active]="activeTab === 'upload'"
        (click)="setActiveTab('upload')"
      >
        Upload Files
      </button>
    </div>

    <div class="manage-files-modal__version-bar" *ngIf="versionMetadataLoaded">
      <app-single-select
        *ngIf="datasetVersionTags.length > 0"
        [options]="viewFilesVersionOptions"
        optionLabel="label"
        placeholder="Select version"
        [ngModel]="activeVersionTag"
        (onChange)="onVersionTagSelected($event)"
      ></app-single-select>
      <span *ngIf="datasetVersionTags.length === 0" class="manage-files-modal__version-empty">
        No versions yet — files below are legacy uploads.
      </span>

      <ng-container *ngIf="!showCreateVersionInput; else createVersionForm">
        <button type="button" class="btn btn-secondary" (click)="openCreateVersionInput()">+ Create new version</button>
      </ng-container>
      <ng-template #createVersionForm>
        <input
          type="text"
          class="manage-files-modal__version-input"
          [(ngModel)]="newVersionTagInput"
          placeholder="e.g. v1.0, monsoon-2026"
          [disabled]="creatingVersion"
        />
        <button type="button" class="btn btn-primary" [disabled]="creatingVersion" (click)="confirmCreateVersion()">
          Create
        </button>
        <button type="button" class="btn btn-secondary" [disabled]="creatingVersion" (click)="cancelCreateVersionInput()">
          Cancel
        </button>
      </ng-template>
    </div>
    <p *ngIf="newVersionTagError" class="manage-files-modal__error">{{ newVersionTagError }}</p>

    <!-- Files tab: compact table with a real Actions column (Download / Delete). -->
    <div *ngIf="activeTab === 'files'" class="manage-files-modal__panel">
      <p *ngIf="!viewFilesListLoading && viewFilesListError" class="manage-files-modal__error">
        {{ viewFilesListError }}
      </p>
      <app-table
        *ngIf="!viewFilesListError"
        class="manage-files-modal__table"
        [columns]="viewFilesTableColumns"
        [data]="viewFilesTableRows"
        [loading]="viewFilesListLoading"
        [pagination]="viewFilesTablePagination"
        [emptyMessage]="'No files are listed for this version yet.'"
        [skeletonRows]="4"
        [scrollable]="false"
        [bordered]="true"
        [hoverable]="true"
      ></app-table>
    </div>

    <!-- Upload tab -->
    <div *ngIf="activeTab === 'upload'" class="manage-files-modal__panel">
      <p class="manage-files-modal__lede" *ngIf="!activeVersionTag">
        Uploading to Legacy (no version). Create a new version first if you want this upload set tracked separately.
      </p>
      <p class="manage-files-modal__lede manage-files-modal__lede--encrypted" *ngIf="encryptedUploadEnabled">
        Files are encrypted in your browser before upload — the platform never sees the plaintext.
      </p>

      <!-- Dataset files (multi-file) -->
      <div class="file-upload-section">
        <div class="file-upload-header">
          <h3 class="file-upload-title">Dataset Files</h3>
          <p class="file-upload-subtitle">Upload the data files or folders for this version. Folder structure is kept under the version folder.</p>
        </div>

        <div
          class="drop-area"
          [class.active]="dragActive"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="drop-message">
            <div class="text-center">
              <svg class="drop-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <p class="drop-text">
                Drag and drop files or folders here, or browse
                <button type="button" class="browse-button" (click)="datasetFileInput.click()">files</button>
                or
                <button type="button" class="browse-button" (click)="datasetFolderInput.click()">a folder</button>
              </p>
              <p class="file-types-hint">All file types are allowed. Folders keep their directory structure.</p>
            </div>
          </div>
          <input #datasetFileInput type="file" multiple (change)="onFileSelected($event)" class="d-none" />
          <input #datasetFolderInput type="file" webkitdirectory (change)="onFileSelected($event)" class="d-none" />
        </div>

        <!-- File tree: pending + uploaded files, folders collapsible, scrolls on its own -->
        <div *ngIf="getTotalFileCount() > 0" class="selected-files-list">
          <div class="upload-summary">
            <div class="upload-summary__text">
              <span><strong>{{ getCompletedFileCount() }}</strong> of <strong>{{ getTotalFileCount() }}</strong> files uploaded</span>
              <span *ngIf="getFailedFileCount() > 0" class="upload-summary__failed">{{ getFailedFileCount() }} failed</span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="getOverallProgressPercent()"></div>
            </div>
          </div>

          <div class="file-tree-toolbar" *ngIf="hasFolders()">
            <button type="button" class="btn-link" (click)="expandAllFolders()">Expand all</button>
            <button type="button" class="btn-link" (click)="collapseAllFolders()">Collapse all</button>
          </div>

          <div class="file-tree-scroller">
            <ng-container *ngFor="let row of getTreeRows(); trackBy: trackTreeRow">
              <div
                *ngIf="row.kind === 'folder'"
                class="tree-row tree-folder"
                [style.padding-left.px]="8 + row.depth * 20"
                (click)="toggleFolder(row.key)"
                role="button"
                [attr.aria-expanded]="!row.collapsed"
              >
                <span class="tree-chevron-wrap" [class.expanded]="!row.collapsed"><svg class="tree-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                <span class="file-icon tree-folder-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                <span class="file-name">{{ row.name }}</span>
                <span class="tree-folder-count">{{ row.count }} {{ row.count === 1 ? 'file' : 'files' }}</span>
              </div>

              <div
                *ngIf="row.kind === 'selected'"
                class="tree-row selected-file-item"
                [style.padding-left.px]="8 + row.depth * 20"
              >
                <div class="file-info">
                  <div class="file-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg></div>
                  <div class="file-details">
                    <span class="file-name" [title]="getFilePath(row.ref)">{{ row.name }}</span>
                    <span class="file-size">{{ getFileSize(row.ref.size) }}</span>
                  </div>
                </div>
                <div class="file-actions-buttons">
                  <button type="button" class="btn-icon btn-delete-file" (click)="removeSelectedFile(row.ref)" title="Remove">
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
                  </button>
                </div>
              </div>

              <div
                *ngIf="row.kind === 'uploaded'"
                class="tree-row uploaded-file-item"
                [style.padding-left.px]="8 + row.depth * 20"
                [class.completed]="row.ref.status === 'completed'"
                [class.error]="row.ref.status === 'error'"
              >
                <div class="file-info">
                  <div class="file-icon">
                    <ng-container *ngIf="row.ref.status !== 'completed'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg></ng-container>
                    <ng-container *ngIf="row.ref.status === 'completed'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></ng-container>
                  </div>
                  <div class="file-details">
                    <span class="file-name" [title]="getFilePath(row.ref.file)">{{ row.name }}</span>
                    <span class="file-size">{{ getFileSize(row.ref.file.size) }}</span>
                  </div>
                </div>
                <div class="file-actions">
                  <span
                    class="file-status"
                    [ngClass]="{
                      'status-pending': row.ref.status === 'pending',
                      'status-uploading': row.ref.status === 'uploading',
                      'status-completed': row.ref.status === 'completed',
                      'status-error': row.ref.status === 'error'
                    }"
                  >
                    {{ row.ref.progress }}%
                  </span>
                  <button type="button" class="btn-icon btn-delete-file" (click)="deleteUploadedFile(row.ref)" title="Remove file">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                  </button>
                </div>
                <div *ngIf="row.ref.status === 'uploading'" class="progress-bar">
                  <div class="progress-fill" [style.width.%]="row.ref.progress"></div>
                </div>
                <div *ngIf="row.ref.error" class="file-error">{{ row.ref.error }}</div>
              </div>
            </ng-container>
          </div>

          <!-- Actions stay outside the scroller so they are always reachable -->
          <div *ngIf="selectedFiles.length > 0" class="manage-files-modal__selected-actions">
            <button type="button" class="btn btn-secondary" (click)="clearSelectedFiles()">Clear All</button>
            <button type="button" class="btn btn-primary" [disabled]="uploading" (click)="uploadAllFiles()">
              {{ uploading ? 'Uploading…' : 'Upload All (' + selectedFiles.length + ')' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Ground Truth (.json) -->
      <div class="file-upload-section">
        <div class="file-upload-header">
          <h3 class="file-upload-title">Ground Truth <span class="required-asterisk">*</span></h3>
          <p class="file-upload-subtitle">Upload the ground truth JSON (.json) file used for evaluation. Required before publishing.</p>
        </div>

        <div class="drop-area" *ngIf="!groundTruthItem">
          <div class="drop-message">
            <div class="text-center">
              <svg class="drop-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <p class="drop-text">
                Drag and drop your file here or
                <button type="button" class="browse-button" (click)="groundTruthInput.click()">browse</button>
              </p>
              <p class="file-types-hint">Allowed File Type: <span class="file-types">JSON</span></p>
            </div>
          </div>
          <input #groundTruthInput type="file" accept=".json" (change)="onGroundTruthSelected($event)" class="d-none" />
        </div>

        <div *ngIf="groundTruthItem" class="uploaded-files-container">
          <div
            class="uploaded-file-item"
            [class.completed]="groundTruthItem.status === 'completed'"
            [class.error]="groundTruthItem.status === 'error'"
          >
            <div class="file-info">
              <div class="file-icon">
                <svg *ngIf="groundTruthItem.status !== 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="groundTruthItem.status === 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="file-details">
                <span class="file-name">{{ groundTruthItem.file.name }}</span>
                <span class="file-size">{{ getFileSize(groundTruthItem.file.size) }}</span>
              </div>
            </div>
            <div class="file-actions">
              <span
                class="file-status"
                [ngClass]="{
                  'status-pending': groundTruthItem.status === 'pending',
                  'status-uploading': groundTruthItem.status === 'uploading',
                  'status-completed': groundTruthItem.status === 'completed',
                  'status-error': groundTruthItem.status === 'error'
                }"
              >
                {{ groundTruthItem.progress }}%
              </span>
              <button
                *ngIf="groundTruthItem.status === 'pending' || groundTruthItem.status === 'error'"
                type="button"
                class="btn-icon btn-upload"
                (click)="uploadGroundTruthFile()"
                title="Upload this file"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 10v2.667A1.333 1.333 0 0 1 12.667 14H3.333A1.333 1.333 0 0 1 2 12.667V10M11.333 5.333 8 2m0 0L4.667 5.333M8 2v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button type="button" class="btn-icon btn-delete-file" (click)="deleteGroundTruthFile()" title="Remove file">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div *ngIf="groundTruthItem.status === 'uploading'" class="progress-bar">
              <div class="progress-fill" [style.width.%]="groundTruthItem.progress"></div>
            </div>
            <div *ngIf="groundTruthItem.error" class="file-error">{{ groundTruthItem.error }}</div>
          </div>
        </div>
      </div>

      <div class="manage-files-modal__publish-bar">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isPublishing || !canPublish()"
          (click)="publish()"
        >
          {{ isPublishing ? 'Publishing…' : 'Publish' }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
